import { TBroadcastScheduleProgramBodySegmentToolkitAdvertisementItem } from '@/features/broadcast-schedule-program/components/BroadcastScheduleProgramBody/components/BroadcastScheduleProgramBodySegmentToolkit/types';
import { TClip } from '@/features/clips/types';

export function getClipAssignations(clip: TClip) {
  const uniqueMap = new Map<string, TBroadcastScheduleProgramBodySegmentToolkitAdvertisementItem>();

  for (const mention of clip.clip_mentions) {
    const workspaces = mention.workspaces || [];
    const clients = mention.clients || [];
    const keywords = mention.keywords || [];
    for (const workspaceId of workspaces) {
      for (const keyword of keywords) {
        for (const clientId of clients) {
          const key = `${workspaceId}::${keyword}::${clientId}`;
          const tentative = Boolean((mention as any).is_tentative ?? mention.is_tentative);

          if (!uniqueMap.has(key)) {
            uniqueMap.set(key, {
              workspaceId,
              keyword,
              clientId,
              isTentative: tentative,
              queryId: mention.query_id,
            });
          } else if (tentative) {
            const existing = uniqueMap.get(key)!;
            existing.isTentative = true;
          }
        }
      }
    }
  }

  return Array.from(uniqueMap.values());
}
